import { PText } from "@porsche-design-system/components-react"
import type { HeaderStatusMessageView } from "@slfinrtl/ui-bff-routes"

interface StatusMessageProps {
	view: HeaderStatusMessageView
}

export const PmpStatusMessage = ({ view }: StatusMessageProps) => {
	return (
		<a href={view.secondaryLink?.href} target="_blank" rel="noreferrer">
			<PText size="xs" color="inherit">
				{view.secondaryMessage}
			</PText>
		</a>
	)
}
